import React from 'react';
import './ProjectsSection.css';

const ProjectsSection = () => {
  const projects = [
    {
      title: 'Solar Projects',
      description: 'Evaluating and developing 3-5 MW solar deployments across India and Southeast Asia. Work includes site viability studies, CAPEX/OPEX modeling, subsidy mapping, and selecting reliable partners for execution.',
      focus: ['Engineering', 'Site Analysis', 'CAPEX/OPEX']
    },
    {
      title: 'DharmaAI',
      description: 'Modernizing classical Indian knowledge systems - spanning scriptures, linguistic origins, and cultural architecture. Building structured digital frameworks, content systems, and long-term preservation tools.',
      focus: ['Knowledge Systems', 'Scriptures', 'Language Origins']
    },
    {
      title: 'Neural Interfaces & Consciousness Research',
      description: 'Fundamental research into next-generation neural interfaces. Exploring EEG-to-language models, brainwave-to-image translation, dream-state decoding, and emerging BCI hardware platforms.',
      focus: ['BCI', 'EEG/MEG', 'Brain-to-Language']
    },
    {
      title: 'Tara Spark',
      description: 'Research funding arm supporting early-stage work in our core domains. Funds labs, doctoral researchers, and early founders exploring consciousness, neural interfaces, and India\'s classical knowledge traditions - from scriptures to language origins.',
      focus: ['Research Grants', 'Deep Tech', 'Frontier Science']
    }
  ];

  return (
    <section id="projects" className="projects-section section-padding">
      <div className="container">
        <div className="projects-header observe-fade">
          <div className="section-label">What We Build</div>
          <h2 className="heading-1">Current Ventures & Initiatives</h2>
          <p className="projects-intro body-large">
            Each project is built to solve technical problems, perform reliably, 
            and deliver measurable results.
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card observe-fade">
              <div className="project-card-inner">
                <h3 className="heading-3 project-title">{project.title}</h3>
                <p className="body-regular project-description">{project.description}</p>
                
                <div className="project-focus">
                  {project.focus.map((item, i) => (
                    <span key={i} className="focus-tag">{item}</span>
                  ))}
                </div>
              </div>
              
              <div className="project-corner-accent"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;